import type { OrderRatingResolvedBy } from 'api/orderRatings.types'
import type { ActivityStatus } from 'api/recoveryAi.types'

// Single source for an OrderRating's resolution → badge vocabulary. The wire
// can't tell an operator's dismissal from a manual resolution, so an operator
// reads as the neutral closed_by_operator; the AI as resolved; nobody as
// unresolved. Callers map this onto their own label where they diverge.
export const resolutionStatusFor = (
  kind: OrderRatingResolvedBy['kind']
): ActivityStatus => {
  if (kind === 'operator') return 'closed_by_operator'
  if (kind === 'ai') return 'resolved'
  return 'unresolved'
}
